import script from "./_base-table-icon-list.vue?vue&type=script&lang=jsx"
export * from "./_base-table-icon-list.vue?vue&type=script&lang=jsx"

const cssModules = {}
import style0 from "./_base-table-icon-list.vue?vue&type=style&index=0&id=001f215a&lang=scss&module=true"
cssModules["$style"] = style0

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__cssModules',cssModules]])

export default __exports__